
import { React } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { LinesChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent, MarkLineComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { getTime, getDate, getDay, formatYaxisNumber } from 'components/common/dateTime';

function Frequency(props) {

    echarts.registerTheme('my_theme', {
        backgroundColor: '#f4cccc'
    });

    echarts.use(
        [TitleComponent, TooltipComponent, MarkLineComponent, UniversalTransition, GridComponent, LinesChart, CanvasRenderer, ScatterChart]
    );



    const options = () => (
        {
            tooltip: {
                trigger: 'item'
            },
            title: {
                // text: 'Site Status',

            },
            lineStyle: {
                type: 'solid'
            },
            legend: {
                show: false
            },
            grid: {
                left: '8%',
                right: '8%',
                bottom: '3%',
                top: 20,
                containLabel: true,
                show: true,

            },
            xAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                splitLine: { show: true },
                show: true,
                // data: ['' ,'24hr', '1Week', '1Month', '3Months'],
                data: props.xAxisData,
            },
            yAxis: {
                type: 'value',
                name: 'No. of Swaps',
                nameLocation: 'middle',
                axisLabel: {
                    formatter: formatYaxisNumber,
                  },
                nameGap: 30,
                splitLine: { show: true }
                // scale: true,

                // nameRotate: 0,

            },
            series: [
                {
                    //data: [20,75,58,65,48],
                    data: props.yAxisData,
                    type: "bar",
                    symbol: 'circle',
                    symbolSize: 10,
                    smooth: false,
                    color: "#414acd",
                    // animationDuration: 2000,
                    // itemStyle: {
                    //     normal: {
                    //         shadowBlur: 2,
                    //         shadowColor: "rgba(0, 0, 0, .12)",
                    //         shadowOffsetX: 2,
                    //         shadowOffsetY: 2
                    //     }
                    // },                    
                    // // showSymbol: false,
                }
            ]
        });
    return (
        <ReactECharts
            echarts={echarts}
            notMerge={true}
            lazyUpdate={true}
            theme={"theme_name"}
            opts={{ renderer: 'svg' }}
            option={options()}
        />
    )
}
export default Frequency




/*import { React } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
 import { BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent,MarkLineComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

function Frequency(props){
   
    echarts.registerTheme('my_theme', {
        backgroundColor: '#f4cccc'
    });

    echarts.use(
        [TitleComponent,TooltipComponent,MarkLineComponent, GridComponent, CanvasRenderer]
    );


    const labelData = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    //['Total Site', 'Commissions','Site under maintinence', 'Site Upcoming'];
    const dataVal = [100, 410, 100, 350, 200, 280, 100]

    const options = () => (
        {
            tooltip: {
                trigger: 'item'
            },
            title: {
                // text: 'Site Status',
            },
            legend: {
                show: false
            },
            grid: {
                left: '8%',
                right: '8%',
                bottom: '3%',
                top: 20,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                axisTick: {
                    show: false
                 },
                
                data: ['' ,'24hr', '1Week', '1Month', '3Months'],
               
            },
            yAxis: {
                type: 'value',
                name: 'No Of Frequency',
                nameLocation: 'middle',
                nameGap: 30,
                //axisLine: { onZero: true ,
                //show: true,
                axisLine: {
                  show: true,
                  onZero: false,
                  
                  lineStyle: {
                    width: 1
                  }
                },
                // nameRotate: 0,

            },
            axisTick: {
                show: true
              },
              series: [
                {
                  //name: 'Line 1',
                  type: 'line',
                  smooth: true,
                  symbolSize: 10,
                  symbol: 'circle',
            
                  lineStyle: {
                    width: 2
                  },
                  areaStyle: {
                    opacity: 0.8,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#ff66ff'
                      },
                      {
                        offset: 1,
                        color: '#fff'
                      }
                    ])
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  label: {
                    show: true
                  },
                  data: ['',20,75,58,65,48],
                } 
              ]
        });
    return (
        <ReactECharts
            echarts={echarts}
            notMerge={true}
            lazyUpdate={true}
            theme={"theme_name"}
            opts={{ renderer: 'svg' }}
            option={options()}
        />
    )
}
export default Frequency;*/











